import { articleSocial } from '@/data/articles/articleSocial';

import { heroSection as blogsHero, blogsSearch } from './blogs.hero';
import { blogsSeo } from './blogs.seo';
import { blogsYouMayAlsoLike } from './blogs.shared';
import { parseDate } from './blogs.utils';
import { aestheticsBlogCards } from './cards.aesthetics';
import { acidRefluxBlogCards } from './cards.acid_reflux';
import { ColicInBabiesBlogCards } from './cards.colic';
import { childhoodFluVaccinationBlogCards } from './cards.childhood_flu_vaccination';
import { gastroenterologyBlogCards } from './cards.gastroenterology';
import { gpBlogCards } from './cards.gp';
import { HeatRashInChildrenBlogCards } from './cards.heat_rash';
import { ObagiHealthBlogCards } from './cards.obagi';
import { paediatricsBlogCards } from './cards.paediatrics';
import { nutritionBlogCards } from './cards.nutrition';
import { privateGpCostBlogCards } from './cards.private_gp_cost';
import { proteinMenopauseBlogCards } from './cards.protein_menopause';
import { sameDayGpBlogCards } from './cards.same_day_gp';
import { sexualHealthBlogCards } from './cards.sexual_health';
import { signsOfLowTestosteroneBlogCards } from './cards.signs_of_low_testosterone';
import { SunBurnInChildrenBlogCards } from './cards.sun_burn';
import { traumaBlogCards } from './cards.trauma';
import { gutMenopauseBlogCards } from './cards.gut_menopause';
import { heartMenopauseBlogCards } from './cards.heart_menopause';
import { metabolicMenopauseBlogCards } from './cards.metabolic_menopause';
import { minorInjuriesClinicBlogCards } from './cards.minor_injuries_clinic';
import { urgentCareBlogCards } from './cards.urgent_care';
import { urologyBlogCards } from './cards.urology';
import { walkInGpBlogCards } from './cards.walk_in_gp';
import { walkInUrgentCareBlogCards } from './cards.walk_in_urgent_care';
import { trtCostBlogCards } from './cards.trt_cost';
import { nhsVsPrivateTrtBlogCards } from './cards.nhs_vs_private_trt';
import { fluVaccination } from './cards.flu_vaccination';
import { fluJab } from './cards.flu_jab';

export const blogData = {
  seo: blogsSeo,
  heroSection: blogsHero,

  search: blogsSearch,
  blogCards: {
    heading: {
      content: '',
      styles: {
        h3: 'font-Mulish font-bold text-royal-875 mb-3 text-xl md:text-2xl',
      },
    },
    cards: [
      ...fluJab,
      ...fluVaccination,
      ...childhoodFluVaccinationBlogCards,
      ...acidRefluxBlogCards,
      ...nhsVsPrivateTrtBlogCards,
      ...signsOfLowTestosteroneBlogCards,
      ...trtCostBlogCards,
      ...walkInUrgentCareBlogCards,
      ...minorInjuriesClinicBlogCards,
      ...gutMenopauseBlogCards,
      ...heartMenopauseBlogCards,
      ...metabolicMenopauseBlogCards,
      ...nutritionBlogCards,
      ...proteinMenopauseBlogCards,
      ...SunBurnInChildrenBlogCards,
      ...HeatRashInChildrenBlogCards,
      ...ColicInBabiesBlogCards,
      ...ObagiHealthBlogCards,
      ...paediatricsBlogCards,
      ...urgentCareBlogCards,
      ...gpBlogCards,
      ...privateGpCostBlogCards,
      ...walkInGpBlogCards,
      ...sameDayGpBlogCards,
      ...aestheticsBlogCards,
      ...traumaBlogCards,
      ...gastroenterologyBlogCards,
      ...urologyBlogCards,
      ...sexualHealthBlogCards,
    ]
      .map((card) => ({ ...card, section: 'health-blog' as const }))
      .sort((a, b) => parseDate(b.date?.content) - parseDate(a.date?.content)),
  },
  followUs: articleSocial,
  youMayAlsoLike: blogsYouMayAlsoLike,
};
